import React from 'react';
import { Check, X } from 'lucide-react';

interface PasswordRequirement {
  label: string;
  met: boolean;
}

interface PasswordValidatorProps {
  password: string;
  show: boolean;
}

export const PasswordValidator: React.FC<PasswordValidatorProps> = ({ password, show }) => {
  if (!show || !password) return null;

  const requirements: PasswordRequirement[] = [
    {
      label: 'At least 8 characters',
      met: password.length >= 8
    },
    {
      label: 'At least one lowercase letter',
      met: /[a-z]/.test(password)
    },
    {
      label: 'At least one uppercase letter',
      met: /[A-Z]/.test(password)
    },
    {
      label: 'At least one number',
      met: /\d/.test(password)
    },
    {
      label: 'At least one special character',
      met: /[@$!%*?&]/.test(password)
    }
  ];

  const allMet = requirements.every(req => req.met);

  return (
    <div className="mt-2 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
      <div className="text-xs font-medium text-gray-700 dark:text-gray-300 mb-2">
        Password requirements:
      </div>
      <div className="space-y-1">
        {requirements.map((req, index) => (
          <div key={index} className="flex items-center gap-2 text-xs">
            {req.met ? (
              <Check size={12} className="text-green-600 dark:text-green-400" />
            ) : (
              <X size={12} className="text-red-500 dark:text-red-400" />
            )}
            <span className={req.met ? 'text-green-700 dark:text-green-300' : 'text-gray-600 dark:text-gray-400'}>
              {req.label}
            </span>
          </div>
        ))}
      </div>
      {allMet && (
        <div className="mt-2 text-xs text-green-700 dark:text-green-300 font-medium">
          ✓ Password meets all requirements
        </div>
      )}
    </div>
  );
};